if (!customElements.get("variant-options")) {
  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("keydown", this.onKeyDown);

        // Listen for cart updates to sync inventory
        if (
          typeof subscribe === "function" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
        }

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute(
            "data-product-handle"
          )}"]`
        );
      }

      connectedCallback() {
        this.whenLoaded.then(() => {
          this.initialize();
        });
      }

      disconnectedCallback() {}

      initialize() {
        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
      }

      onCartUpdate() {
        this.updateVariantStatuses();
        this.updateDropdownButtons();
      }

      onKeyDown(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
          // this.onVariantChange();
        }
      }

      onVariantChange() {
        const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeStartEvent);
        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.updateDropdownButtons();

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          this.lenOfVariantOptions =
            document.querySelectorAll("variant-options").length;
          if (this.lenOfVariantOptions === 1) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
        }
        const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeEndEvent);
      }

      updateGallery() {
        const mediaGallery = document.getElementById(
          `MediaGallery-${this.dataset.section}`
        );
        if (!mediaGallery) return;

        let media_id = false;
        if (this.currentVariant && this.currentVariant.featured_media) {
          media_id = this.currentVariant.featured_media.id;
        }

        // SKU-based filtering
        let sku = this.currentVariant?.sku;

        // Bundle fallback: extract SKU from featured_media alt text
        if (!sku && media_id && typeof mediaGallery.getSkuFromMediaId === 'function') {
          sku = mediaGallery.getSkuFromMediaId(media_id);
        }

        if (sku && typeof mediaGallery.filterSlidesBySku === 'function') {
          mediaGallery.filterSlidesBySku(sku, media_id);
          return;
        }

        // Fallback: hashtag-based option filtering
        mediaGallery.filterSlides(this.options, media_id, true);
      }

      updateDropdownButtons() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option")
        );
        this.options = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked
            )?.value || ""
          );
        });

        fieldsets.forEach((fieldset) => {
          const dropdown = fieldset.querySelector(
            ".wt-product__option__dropdown"
          );
          if (dropdown) {
            const checkedInput = fieldset.querySelector(
              "fieldset input:checked"
            );
            if (!checkedInput) return;
            const isInputDisabled =
              checkedInput?.classList.contains("disabled");
            dropdown.classList.toggle(
              "wt-product__option__dropdown--unavailable",
              isInputDisabled
            );
          }
        });
      }

      updateOptions() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option")
        );
        this.options = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked
            )?.value || ""
          );
        });

        this.checkedOptions = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked
            ) || ""
          );
        });

        fieldsets.forEach((fieldset, index) => {
          const selectedOption = this.options[index];

          if (!selectedOption) return;

          const valueElement = fieldset.querySelector(
            ".wt-product__option__title .value"
          );

          // Check if the selected option is out of stock
          const selectedInput = fieldset.querySelector("input:checked");
          const isOutOfStock =
            selectedInput && selectedInput.classList.contains("disabled");

          // Remove any existing out-of-stock message
          const existingMessage = fieldset.querySelector(
            ".out-of-stock-message"
          );
          if (existingMessage) {
            existingMessage.remove();
          }

          valueElement.innerHTML = selectedOption;

          // Buffer Logic
          // Fallback: If bufferQty > 0, assume enabled to prevent attribute issues
          const bufferQty = parseInt(this.dataset.bufferQty || 0);
          const bufferEnable = this.dataset.bufferEnable === "true";
          const ignoreBuffer = this.dataset.ignoreBuffer === "true";

          let isBufferedOut = false;

          // Check if this specific option selection results in a buffered-out variant
          if (bufferEnable && !ignoreBuffer && selectedInput) {
            const matchingVariant = this.getVariantData().find((variant) => {
              return !variant.options
                .map((opt, i) => {
                  // Loose equality for robust matching
                  return this.options[i] == opt;
                })
                .includes(false);
            });

            if (matchingVariant) {
              const invMap = this.getInventoryMap();
              const qty = invMap[matchingVariant.id];
              if (
                matchingVariant.available &&
                qty !== undefined &&
                qty <= bufferQty
              ) {
                isBufferedOut = true;
              }
            }
          }

          // Add out-of-stock message if needed
          if (isOutOfStock || isBufferedOut) {
            const outOfStockSpan = document.createElement("span");
            outOfStockSpan.className = "out-of-stock-message";
            outOfStockSpan.textContent = " COMING SOON";
            outOfStockSpan.style.color = "#ff4f4f";
            outOfStockSpan.style.marginLeft = "8px";
            outOfStockSpan.style.fontWeight = "bold";
            // Check if already appended to avoid duplicates
            if (
              !valueElement.parentNode.querySelector(".out-of-stock-message")
            ) {
              valueElement.insertAdjacentElement("afterend", outOfStockSpan);
            }
          }

          const dropdownSpan = fieldset.querySelector(
            ".wt-product__option__dropdown span"
          );
          if (dropdownSpan) dropdownSpan.innerHTML = selectedOption;
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData()?.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute(
          "data-featured-image",
          this.currentVariant?.featured_media?.preview_image?.src
        );
        this.setAttribute(
          "data-featured-image-id",
          this.currentVariant?.featured_media?.id
        );

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`
        );
        modalContent.prepend(newMediaModal);
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      }

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData?.filter((variant) =>
          this.isVariantAvailable(variant)
        );
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];
        inputWrappers.forEach((option, index) => {
          if (index === 0 && this.currentVariant?.options.length > 1) return;
          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];
          const previousOptionSelected =
            inputWrappers[index - 1]?.querySelector(":checked")?.value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) =>
                this.isVariantAvailable(variant) &&
                variant[`option${index}`] === previousOptionSelected
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      isVariantAvailable(variant) {
        if (!variant.available) return false;

        const bufferQty = parseInt(this.dataset.bufferQty || 0);
        // Fallback: If bufferQty > 0, assume enabled
        const bufferEnable = this.dataset.bufferEnable === "true";
        const ignoreBuffer = this.dataset.ignoreBuffer === "true";

        if (bufferEnable && !ignoreBuffer) {
          const invMap = this.getInventoryMap();
          const qty = invMap[variant.id];
          // If available but qty <= buffer, treat as unavailable (Coming Soon)
          if (qty !== undefined && qty <= bufferQty) {
            return false;
          }
        }
        return true;
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
          } else {
            input.classList.add("disabled");
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability"
        );
        if (!pickUpAvailability) return;

        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (
          this.currentVariant &&
          this.isVariantAvailable(this.currentVariant)
        ) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        try {
          productForm?.handleErrorMessage();
        } catch (err) {
          console.log(err);
        }
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant?.id;
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;

        fetch(
          `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
          .then((response) => response.text())
          .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentVariant?.id !== requestedVariantId) return;

            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const destination = document.getElementById(
              `price-${this.dataset.section}`
            );
            const source = html.getElementById(
              `price-${
                this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section
              }`
            );
            const skuSource = html.getElementById(
              `Sku-${
                this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section
              }`
            );
            const skuDestination = document.getElementById(
              `Sku-${this.dataset.section}`
            );
            const inventorySource = html.getElementById(
              `Inventory-${
                this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section
              }`
            );
            const inventoryDestination = document.getElementById(
              `Inventory-${this.dataset.section}`
            );

            if (source && destination) destination.innerHTML = source.innerHTML;
            if (inventorySource && inventoryDestination)
              inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle(
                "visibility-hidden",
                skuSource.classList.contains("visibility-hidden")
              );
            }

            const price = document.getElementById(
              `price-${this.dataset.section}`
            );

            if (price) price.classList.remove("visibility-hidden");

            if (inventoryDestination)
              inventoryDestination.classList.toggle(
                "visibility-hidden",
                inventorySource.innerText === ""
              );

            const bufferMessageSource = html.getElementById(
              `InventoryBufferMessage-${
                this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section
              }`
            );
            const bufferMessageDestination = document.getElementById(
              `InventoryBufferMessage-${this.dataset.section}`
            );
            if (bufferMessageSource && bufferMessageDestination) {
              bufferMessageDestination.innerHTML =
                bufferMessageSource.innerHTML;
            }

            // Update Quantity Max
            const qtyInputDestination = document.querySelector(
              `#product-form-${this.dataset.section} .js-counter-quantity`
            );
            const qtyInputSource = html.querySelector(
              `#product-form-${this.dataset.section} .js-counter-quantity`
            );

            if (qtyInputDestination && qtyInputSource) {
              const newMax = qtyInputSource.getAttribute("max");
              const newLimit = qtyInputSource.getAttribute(
                "data-inventory-limit"
              );
              qtyInputDestination.setAttribute("max", newMax);
              qtyInputDestination.setAttribute(
                "data-inventory-limit",
                newLimit
              );

              // Also reset formatted value if current value exceeds new max
              if (parseInt(qtyInputDestination.value) > parseInt(newMax)) {
                qtyInputDestination.value = newMax;
              }

              const currentMin =
                parseInt(qtyInputDestination.getAttribute("min")) || 1;
              if (
                parseInt(qtyInputDestination.value) < currentMin &&
                parseInt(newMax) >= currentMin
              ) {
                qtyInputDestination.value = currentMin;
              }
              // Check if we need to disable button based on new max (initial load state)
              if (parseInt(newMax) === 0) {
                const addButton = document.getElementById(
                  `ProductSubmitButton-${this.dataset.section}`
                );
                if (addButton) {
                  this.toggleAddButton(true, "Limit Reached", false);
                }
              }
            }

            const addButtonUpdated = html.getElementById(
              `ProductSubmitButton-${sectionId}`
            );

            let buttonText = window.variantStrings.soldOut;
            if (addButtonUpdated) {
              const textSpan = addButtonUpdated.querySelector(".submit-title");
              if (textSpan) {
                buttonText = textSpan.textContent;
              } else {
                buttonText = addButtonUpdated.textContent;
              }
            }

            if (addButtonUpdated) {
              const newLimit = addButtonUpdated.getAttribute(
                "data-inventory-limit"
              );
              const currentButton = document.getElementById(
                `ProductSubmitButton-${sectionId}`
              );
              if (currentButton && newLimit) {
                currentButton.setAttribute("data-inventory-limit", newLimit);
              }
            }

            this.toggleAddButton(
              addButtonUpdated
                ? addButtonUpdated.hasAttribute("disabled")
                : true,
              buttonText
            );

            // Re-run cart update logic to ensure state is correct for new variant + current cart
            this.onCartUpdate();

            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: sectionId,
                html,
                variant: this.currentVariant,
              },
            });
          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          );
        return this.variantData;
      }

      getInventoryMap() {
        if (!this.inventoryMap) {
          const script = this.querySelector("[data-inventory-map]");
          if (script) {
            this.inventoryMap = JSON.parse(script.textContent);
          } else {
            this.inventoryMap = {};
          }
        }
        return this.inventoryMap;
      }
    }
  );
}
// customElements.define('variant-options', VariantOptions);
